import myRestaurants from '@/screens/my-restaurants/List'
import auth from './middleware/auth'

export default [
  {
    path: '/my-restaurants',
    component: myRestaurants,
    name: 'My restaurants',
    meta: {
      requireAuth: true,
      permissions: ['manager', 'buyer', 'financier'],
      middleware: { auth }
    }
  }
]
